
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["VF2","VF","ULLMANN"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "ac800c6237196ea9e142.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "ac800c6237196ea9e142.worker.js");
					addMethods(w, methods)
					
					return w
				}
			